export default __webpack_public_path__ + "static/media/陳伶志.173672b7.png";